import { Money } from '@libs/money/money.interfaces';
import { Color, Type } from '@ui/components/Icon/Icon.interfaces';

export interface ServicePackage {
    name: ServicePackageName;
    isRecommended: boolean;
    title: string;
    usps: ServicePackageUSP[];
    price: Money;
    originalPrice?: Money | null;
    link: string | null;
}

export interface ServicePackageUSP {
    title: string | null;
    text: string;
    icon: Type;
    showBadge?: boolean;
    badgePrice?: string;
    badgeColor?: 'lightGrey' | 'green';
    color?: Color;
}

export enum ServicePackageName {
    None = 'none',
    Basic = 'basic',
    Premium = 'premium',
}
